/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import moment from 'moment';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_ADJUST,
  screenData: data,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_ADJUST,
  detailScrData: data,
});
// dispatch Quarter From

export const dispatchQtrRange = (data) => ({
  type: actionTypes.GET_FROM_ADJUST,
  payload: data,
});

// select option dispatch
export const getSelectedOption = (data) => ({
  type: actionTypes.SELECT_OPTION,
  payload: data,
});
// refresh data
export const refreshCmsAdjustment = () => ({
  type: actionTypes.SET_REFRESH_DATA_ADJUSTMENT_CMS,
  payload: {},
});
export const refreshCmsAdjustmentDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_ADJUSTMENT_CMS_DISPLAY,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjAdjustment = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_ADJUST,
  payload: data,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_ADJUST,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgAdjust = (data) => ({
  type: actionTypes.GET_ERROR_MSG_ADJUST,
  payload: data,
});
// error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgAdjust([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgAdjust([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_ADJUST,
  payload: data,
});
// on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_ADJUST,
  payload: data,
});
// dispatch grp by qtr data
export const setFinalGroupByQtr = (data) => ({
  type: actionTypes.GROUP_BY_QTR_DATA,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
// dispatch adjustment grid
export const dispatchCmsAdjustment = (data) => ({
  type: actionTypes.GET_CMS_ADJUSTMENT_DATA,
  payload: data,
});
export const getCmsAdjustment = (value) => (dispatch) => {
  dispatch(dispatchCmsAdjustment([]));
  return axios
    .post(serviceEndPoint.GET_CMS_ADJUSTMENT, value)
    .then((response) => {
      if (response.data.cmsreportAdjustmentDetailsVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchCmsAdjustment(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchCmsAdjustment([]));
    });
};
// dispatch cms rebate group
export const dispatchCmsRebateGroup = (data) => ({
  type: actionTypes.GET_CMS_REBATE_GROUP,
  payload: data,
});
export const getCmsRebateGroup = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.LIST_CMS_REPORT_GROUPS}?utilQtr=${value.utilQtr}`)
    .then((response) => {
      return dispatch(dispatchCmsRebateGroup(response.data));
    })
    .catch((response) => {
      dispatch(dispatchCmsRebateGroup([]));
    });
};
export const dispatchCmsRebateGroupName = (data) => ({
  type: actionTypes.GET_CMS_REBATE_GROUP_NAME,
  payload: data,
});
// dispatch cms rebate group list
export const dispatchCmsRebateGroupList = (data) => ({
  type: actionTypes.GET_CMS_LIST_REBATE_GROUP,
  payload: data,
});
export const getCmsRebateGroupListData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.LIST_CMS_REBATE_PROGRAM, value)
    .then((response) => {
      return dispatch(dispatchCmsRebateGroupList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchCmsRebateGroupList([]));
    });
};
export const dispatchCmsRebateGroupNameList = (data) => ({
  type: actionTypes.GET_CMS_LIST_REBATE_GROUP_NAME,
  payload: data,
});

export const getCMSRptAdjSingleRpcQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.CMS_RPT_ADJ_RPT_SGL_QTR, value)
    .then((response) => response.data?.data || '')
    .catch((response) => '');
};
export const getCMSRptAdjLoadQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.CMS_RPT_ADJ_RPT_LOAD_QTR, value)
    .then((response) => response.data?.data || '')
    .catch((response) => '');
};
export const getCMSRptAdjGrpRpcQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.CMS_RPT_ADJ_RPT_GRP_QTR, value)
    .then((response) => response.data?.data || '')
    .catch((response) => '');
};
export const getCMSMaxQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.REBATE_MAX_QTR_ENROLL, value)
    .then((response) => response.data?.data?.maxFrozenQtrDisplay || '')
    .catch((response) => '');
};
